<template>
<div class="chapter">
<div class="inner_page">
<p class="fmdedi"><a id="dedication"><b>Dedication</b></a></p><a id="dedication">
<p class="fmnoindent1">TO JILL AND Laddie Lucas, whose continual encouragement made me turn my flying stories into this book. They wagered me a fiver I wouldn’t do it … I’ve won!</p>
<p class="right">DBW, Horne Grange, Surrey</p>
</a><p class="fmack"><a id="dedication"></a><a id="acknowledgements"><b>Acknowledgements</b></a></p><a id="acknowledgements">
<p class="fmnoindent">I HAVE DONE my best to trace the copyright holders of all the pictures used in this book, and apologize to any I may have missed out. I would like to thank the following good friends for their help, advice and photographs: Jeffrey Quill OBE AFC FRAeS, the famous Spitfire test pilot; Air Chief Marshal Sir Denis Smallwood GBE KCB DSO DFC; Air Marshal Sir Patrick Dunn KBE CB DFC; Wing Commander Eric Viles MBE of the ATA Association; Squadron Leader A. C. Bartley DFC &amp; bar; Mike Tagg of the RAF Museum, Hendon; Elwyn Blacker, of Pardoe Blacker, Lingfield; and Bill Port of the Bentley Drivers Club. Wing Commander P. B. ‘Laddie’ Lucas CBE DSO DFC galvanized me into approaching my desk and introduced me to the aviation author and historian Norman Franks, who guided me through the pitfalls of writing and whose knowledge of military aviation history and his own writing skills were invaluable.</p>
<p class="fmindent">Lastly, my dear friend Hartley Shawcross, for taking the time and trouble to write the flattering foreword to my book.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?280be28f